import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chat: null,
  ConversationType: "Individual",
  conversationId: null,
  isInitial: true,
  isSubmitted: false,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatData: (state, action) => {
      state.chat = action?.payload;
    },
    setConversationType: (state, action) => {
      state.ConversationType = action?.payload;
    },
    setConversationId: (state, action) => {
      state.conversationId = action?.payload;
    },
    setInitial: (state, action) => {
      state.isInitial = action?.payload;
    },
    setSubmitted: (state, action) => {
      state.isSubmitted = action?.payload;
    },
    resetChatState: () => ({ ...initialState }),
  },
});

// Action creators are generated for each case reducer function
export const {
  setChatData,
  setConversationType,
  setConversationId,
  setInitial,
  setSubmitted,
  resetChatState,
} = chatSlice.actions;

export default chatSlice.reducer;
